import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Card,
  CardContent,
  CardActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import Reportmodal from "./Reportmodal";

const Reports = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [tabIndex, setTabIndex] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [cities, setCities] = useState(null);
  const [generatedReportsData, setGeneratedReportsData] = useState([]);
  const [page, setPage] = useState(0); // <-- track current page
  const [limit] = useState(10); // number of rows per page
  const [totalCount, setTotalCount] = useState(0); // backend should return total rows

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getCityNames();
  }, []);

  const reports = [
    {
      title: "Fuel History Report",
      description:
        "Provides a detailed record of fuel-related activities for vehicles within a specified time frame. It includes comprehensive insights into fuel consumption patterns and volume changes.",
      summary:
        "Comprehensive insights into fuel consumption patterns and volume changes data within a specified period.",
      reportType: "Fuel History",
    },
    {
      title: "Overall Report",
      description:
        "An overall booking report provides a comprehensive summary of all booking data within a specified period. It includes details such as the total number of bookings, customer information, booking dates, service types, and other relevant metrics.",
      summary:
        "An overall booking report provides a comprehensive summary of all booking data within a specified period.",
      reportType: "Overall",
    },
    {
      title: "Overall Inquiry Report",
      description:
        "An overall inquiry report provides a comprehensive summary of all inquiry data within a specified period. It includes details such as the total number of inquiry, customer information, inquiry dates, service types, and other relevant metrics.",
      summary:
        "An overall inquiry report provides a comprehensive summary of all inquiry data within a specified period.",
      reportType: "Inquiry Details",
    },
    {
      title: "Booking Call Reports",
      description:
        "Booking Call Reports provide a detailed overview of all customer booking-related calls within a selected period. It includes information such as call outcomes, customer details, booking status, follow-ups, and agent performance insights.",
      summary:
        "A detailed report of all booking-related customer calls and their outcomes within a selected period.",
      reportType: "Booking Call Details",
    },
    {
      title: "Cancelled Booking Report",
      description:
        "An overall cancellation report provides a comprehensive summary of all cancellation data within a specified period. It includes details such as the total number of cancellations, customer information, cancellation dates, service types, and other relevant metrics.",
      summary:
        "An overall cancellation report provides a comprehensive summary of all cancellation data within a specified period.",
      reportType: "Cancellation Details",
    },
    {
      title: "Vehicle Revenue Report",
      description:
        "Generate detailed reports on vehicle revenue, occupancy rates, booking counts, and overall performance metrics. Optimize fleet operations by assessing vehicle revenue, daily occupancy, and booking count summaries.",
      summary:
        "Vehicle revenue and occupancy reports provide actionable insights for bookings and operational performance.",
      reportType: "Vehicle Revenue",
    },
    // {
    //   title: "Delivery Report Agent Wise",
    //   description:
    //     "Report provides an agent-wise breakdown of delivery operations, highlighting each delivery agent's performance and assignments. Includes agent details and booking counts.",
    //   summary:
    //     "Report provides an agent-wise breakdown of delivery operations, highlighting agent performance and assignments.",
    //   reportType: "Delivery Report Agent Wise",
    // },
    // {
    //   title: "Pickup Report Agent Wise",
    //   description:
    //     "Report provides an agent-wise breakdown of pickup operations, highlighting each pickup agent's performance and assignments. Includes agent details and booking counts.",
    //   summary:
    //     "Report provides an agent-wise breakdown of pickup operations, highlighting pickup agent performance and assignments.",
    //   reportType: "Pickup Report Agent Wise",
    // },
    {
      title: "Booking Charges",
      description:
        "The Booking Charges Report provides a comprehensive overview of all charges associated with vehicle bookings. Includes line-item details like comments, amounts, and charge types for each booking.",
      summary:
        "The Booking Charges Report provides transparency in financial transactions with detailed line-item charges.",
      reportType: "Booking Charges",
    },
    {
      title: "Delivery and Pickup Analytics",
      description:
        "A Delivery and Pickup Analytics report provides a comprehensive summary of all delivery and pickup activities within a specified period and location. It includes details such as total deliveries, pickups completed, pending requests, customer information, service timings, and other key operational metrics.",
      summary:
        "A Delivery and Pickup Analytics report provides a comprehensive summary of all delivery and pickup activities within a specified period and location.",
      reportType: "Delivery and Pickup Analytics",
    },
    {
      title: "Customer Feedback",
      description:
        "The Customer Feedback Report provides a comprehensive overview of all feedback received from customers regarding their booking experiences. Includes comments, ratings, and other relevant information.",
      summary:
        "The Customer Feedback Report provides insights into customer satisfaction and areas for improvement.",
      reportType: "Customer Feedback",
    },
  ];

  const handleDownload = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };


  useEffect(() => {
    generatedreports(page); // call API whenever page changes
  }, [page, tabIndex]);

  const generatedreports = async (currentPage = 0) => {
    try {
      const offset = currentPage * limit;
      const response = await fetch(
        `${apiUrl}/api/generatedreports?limit=${limit}&offset=${offset}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setGeneratedReportsData(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0); // assuming backend returns count
      }
    } catch (error) {
      console.error("Error generating report:", error);
    }
  };

  const totalPages = Math.ceil(totalCount / limit);

  return (
    <div>
      {openModal && (
        <Reportmodal
          open={openModal}
          onClose={() => setOpenModal(false)}
          reportTypeData={selectedReport || {}}
          lookUpList={{ cityData: cities }}
          hubList={[{ id: "1", hubName: "Hub A" }]}
          // dateFilterType={
          //   selectedReport?.reportType === "Cancellation Details" || selectedReport?.reportType === "Customer Feedback" || selectedReport?.reportType === "Booking Call Details"
          //     ? {
          //       createdAt: "Generated On",
          //     }
          //     : {
          //       createdAt: "Generated On",
          //       bookFrom: "Book From",
          //       bookTo: "Book To",
          //     }
          // }
          dateFilterType={
            selectedReport?.reportType === "Delivery and Pickup Analytics"
              ? {
                bookFrom: "Book From",
              }
              : selectedReport?.reportType === "Cancellation Details" ||
                selectedReport?.reportType === "Customer Feedback" ||
                selectedReport?.reportType === "Booking Call Details"
                ? {
                  createdAt: "Generated On",
                }
                : {
                  createdAt: "Generated On",
                  bookFrom: "Book From",
                  bookTo: "Book To",
                }
          }
          onGenerate={(data) => {
            setOpenModal(false);
          }}
          generatedreports={generatedreports}
        />
      )}

      <div className="flex flex-col flex-auto w-full">
        <div className="flex flex-wrap w-full max-w-screen-2xl mx-auto p-6 md:p-8">
          <div className="flex flex-wrap items-center justify-between w-full">
            <div>
              <h2 className="text-3xl font-semibold tracking-tight leading-8">
                Report Management
              </h2>
              <div className="font-medium tracking-tight text-gray-500">
                Fleet booking management
              </div>
            </div>
          </div>

          <div className="flex flex-col flex-auto w-full mt-8">
            <Tabs
              value={tabIndex}
              onChange={(_, newValue) => setTabIndex(newValue)}
            >
              <Tab label="Reports" />
              <Tab label="Download Reports" />
            </Tabs>

            {/* Reports Tab */}
            {tabIndex === 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full mt-6">
                {reports.map((report, idx) => (
                  <Card
                    key={idx}
                    className="flex flex-col bg-white shadow rounded-lg hover:shadow-lg transition h-full"
                  >
                    <CardContent className="flex flex-col flex-grow">
                      <h3 className="text-xl font-semibold mb-2">
                        {report.title}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4">
                        {report.description}
                      </p>
                    </CardContent>
                    <CardActions className="mt-auto">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          setSelectedReport(report);
                          setOpenModal(true);
                        }}
                      >
                        Generate
                      </Button>
                    </CardActions>
                  </Card>
                ))}
              </div>
            )}

            {/* Download Reports Tab */}
            {tabIndex === 1 && (
              <div className="p-6 bg-white shadow rounded-2xl overflow-hidden mt-6">
                <h3 className="mb-4 font-semibold text-lg">Ticket Details</h3>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Report Name</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>Date Filter Type</TableCell>
                      <TableCell>Created At</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {generatedReportsData.map((row, i) => (
                      <TableRow key={i} hover>
                        <TableCell>{row.reportName}</TableCell>
                        <TableCell>
                          {new Date(row.startDate).toLocaleString()}
                        </TableCell>
                        <TableCell>
                          {row.endDate
                            ? new Date(row.endDate).toLocaleString()
                            : "-"}
                        </TableCell>
                        <TableCell>{row.dateFilterType}</TableCell>
                        <TableCell>
                          {new Date(row.createdOn).toLocaleString()}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => handleDownload(row.donwloadUrl)}
                          >
                            Download
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                    {generatedReportsData?.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No Data Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                {/* Pagination */}
                <div className="flex justify-between items-center mt-4">
                  <Button
                    variant="outlined"
                    disabled={page === 0}
                    onClick={() => setPage((prev) => prev - 1)}
                  >
                    Previous
                  </Button>
                  <span>
                    Page {page + 1} of {totalPages || 1}
                  </span>
                  <Button
                    variant="outlined"
                    disabled={page + 1 >= totalPages}
                    onClick={() => setPage((prev) => prev + 1)}
                  >
                    Next
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
